<template>
  <div>
    <h4>Add your logo to your event's Attendee Dashboard</h4>
    <c-upload-image
      id="attendee_dashboard_logo"
      title=""
      :image_url="dashboard_logo.uploadcare_url"
      :uuid="dashboard_logo.uploadcare_uuid"
      helpText="(.png, or .jpg) If the file has more than 200 pixels height it will be resized."
      existing-images-url="/api/media-library/attendee_dashboard_logo/templates"
      @upload="uploadLogo"
      @remove="removeLogo"
    />
  </div>
</template>
<script>

export default {
  props: ['conferenceId'],
  data() {
    return {
      dashboard_logo: {
        uploadcare_url: null,
        uploadcare_uuid: null,
      },
    }
  },
  mounted() {
    this.fetch();
  },
  methods: {
    fetch() {
      axios.get(`/api/conferences/${this.conferenceId}/uploads/attendee_dashboard_logo`).then((res) => {
        this.dashboard_logo = res.data?.data || res.data || {};
      }).catch(() => {
      }).finally(() => {
        this.$emit('loaded');
      })
    },
    uploadLogo(file) {
      axios.put(`/api/conferences/${this.conferenceId}/uploads/attendee_dashboard_logo`, {
        uploadcare_uuid: file.uuid,
      }).then((res) => {
        this.dashboard_logo = res.data?.data || res.data || {};

        notifier.success('Success', 'The file has been uploaded successfully.');
      }).catch((error) => {
        notifier.error(error?.flash || 'Error');
      });
    },
    removeLogo() {
      axios.delete(`/api/conferences/${this.conferenceId}/uploads/attendee_dashboard_logo`).then(() => {
        this.dashboard_logo = {
          uploadcare_url: null,
          uploadcare_uuid: null,
        };

        notifier.success('Success', 'The file has been removed successfully.');
      }).catch((error) => {
        notifier.error(error?.flash || 'Error');
      });
    },
  }
}
</script>